import * as yup from "yup";

export const resaleValidation = yup.object().shape({
  resale_price: yup
    .string()
    .required("Price is required")
    .matches(/^[0-9]+(\.[0-9]{1,2})?$/, "Price must be a valid number"),

  token: yup.string().oneOf(["baf"], "Invalid token selection").default("baf"),

  is_physical_asset: yup.boolean().required(),

  tracking_id: yup.string().when("is_physical_asset", {
    is: true,
    then: (schema) => schema.required("Track ID is required"),
    otherwise: (schema) => schema.notRequired()
  })

  // nft_images: yup.array()
  //   .of(
  //     yup.mixed()
  //       .test('fileSize', 'File size too large', (value) => {
  //         if (!value) return true;
  //         return value.size <= 25 * 1024 * 1024;
  //       })
  //       .test('fileType', 'Invalid file type', (value) => {
  //         if (!value) return true;
  //         const supportedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  //         return supportedTypes.includes(value.type);
  //       })
  //   )
  //   .min(1, "At least one image is required")
});

export const voteSchema = yup.object().shape({
  option_id: yup.number().required("Please select an option")
});
